
import { Component, Vue, Watch } from 'vue-property-decorator';
import NavInfo, { CounterConfig } from '@/interfaces/navInfoInterface';
import NavBlackList from '@/Configurations/navBlackList';

@Component({})
export default class NavBar extends Vue {
  private timerFlag = 0;
  private vconsoleCounter: number = 0;
  private counterTriggers: any; // 预留倒计时分时处理的trigger数组或者函数
  private configInstance: NavInfo = {}; // nav 的配置实例
  private defaultNavConfig: NavInfo = {
    // nav默认配置
    zIndex:1,
    showNavBar: true,
    showTitle: true,
    showBackIcon: true,
    type: 'normal',
    btnGroup: [],
    searchConfig: {
      searchCallbackTiming: 'onSearch',
      searchPlaceholder: '搜索'
    },
    counterConfig: {
      counterText: '倒计时',
      counterTimerFormat: 'hh:mm:ss'
    },
    btnSplitLine: false,
    splitLineColor: '#5F6368'
  };
  private isHaveButtonGroup: boolean = true; // 是否显示右侧按钮组
  private rightZoneClass: 'custom_zone_split' | 'custom_zone_normal' = 'custom_zone_normal'; // 右侧的类名控制
  private searchWord: string = ''; // 搜索字符串
  private titleClass: string = ''; // title 的类名
  private title: string = ''; // title显示的字符串
  private timeLeft: number = 0; // 倒计时剩余时间
  private timeShow: string = '00:00:00'; // 倒计时显示时间

  get navInfo() {
    return this.$store.getters.getNavInfo;
  }

  @Watch('navInfo') getCount(newVal: NavInfo) {
    this.renderNavBar(newVal);
  }
  @Watch('$route', { immediate: true })
  private changeRouter(route: any) {
    this.$store.commit('clearNavInfo');
  }
  @Watch('searchWord', { immediate: true })
  private touchSearch(val: string) {
    if (!this.configInstance.searchConfig) return;
    if (typeof this.configInstance.searchConfig.searchCallback !== 'function') return;
    if (this.configInstance.searchConfig.searchCallbackTiming === 'keydown') {
      this.configInstance.searchConfig.searchCallback(val);
    }
  }

  showVConsole() {
    this.vconsoleCounter++;
    if (this.vconsoleCounter === 5) {
      if (document.getElementById('__vconsole')!.style.display === 'block') {
        document.getElementById('__vconsole')!.style.display = '';
      } else if (document.getElementById('__vconsole')!.style.display === '' || document.getElementById('__vconsole')!.style.display === 'none') {
        document.getElementById('__vconsole')!.style.display = 'block';
      }
    }
    setTimeout(() => {
      this.vconsoleCounter = 0;
    }, 5000);
  }

  renderNavBar(navInfo: NavInfo) {
    // 渲染构建整个nav-bar组件
    this.configInstance = Object.assign({}, this.defaultNavConfig, navInfo);
    if (!this.handleBlackList()) return;
    if (this.configInstance.showNavBar === false) return;
    this.makeRightZoneClass(this.configInstance.type ? this.configInstance.type : 'normal');
    this.configInstance.title ? (this.title = this.configInstance.title) : (this.title = this.$route.name as string);
    !this.configInstance.btnGroup || this.configInstance.btnGroup.length === 0 ? (this.isHaveButtonGroup = false) : (this.isHaveButtonGroup = true);
    if (!this.configInstance.counterConfig?.counterEndTime) return;
    const endTime = this.configInstance.counterConfig.counterEndTime as Date;
    const DateNow = new Date();
    if (!this.configInstance.counterConfig.counterText) this.configInstance.counterConfig.counterText = '倒计时';
    this.timeLeft = endTime.getTime() - DateNow.getTime();
    this.startCountDown(this.configInstance.counterConfig as any);
  }
  handleBlackList(): boolean {
    // 黑名单处理
    if (this.$route.name === 'home') return false;
    NavBlackList.forEach(item => {
      const reg = new RegExp(item as string);
      if (reg.test(this.$route.path)) {
        this.configInstance.showNavBar = false;
        return false;
      }
    });
    return true;
  }
  startCountDown(counterConfig: CounterConfig) {
    // 开始倒计时\
    if (this.timerFlag !== 0) clearInterval(this.timerFlag);
    this.timerFlag = setInterval(() => {
      if (Array.isArray(counterConfig.counterTriggers)) {
        // 函数重载处理在这里做，应该在上面做 我懒得写了
      }
      if(typeof counterConfig.everySecTriggers === 'function'){
        //剩余秒的回调
        counterConfig.everySecTriggers(Math.round(this.timeLeft/1000));
      }
      if (this.timeLeft < 0 || this.timeLeft === 0) {
        this.timeShow = '00:00:00';
        clearTimeout(this.timerFlag);
        if (typeof counterConfig.counterTriggers === 'function') {
          counterConfig.counterTriggers();
        }
        return;
      }
      this.makeTimeString(counterConfig);
      this.timeLeft -= 1000;
    }, 1000);
  }
  makeTimeString(counterConfig: CounterConfig) {
    // 生成倒计时字符串
    if (!counterConfig.counterTimerFormat) counterConfig.counterTimerFormat = 'hh:mm:ss';
    const showHours = /hh/.test(counterConfig.counterTimerFormat);
    const showMinutes = /mm/.test(counterConfig.counterTimerFormat);
    const showSeconds = /ss/.test(counterConfig.counterTimerFormat);
    const leftHours = this.timeLeft / 1000 / 60 / 60;
    const leftMinutes = Number('0.' + leftHours.toString().replace(/\d+\.(\d*)/, '$1')) * 60;
    const leftSecond = Number('0.' + leftMinutes.toString().replace(/\d+\.(\d*)/, '$1')) * 60;

    this.timeShow = `${makeTimeBitString(Math.floor(leftHours).toString(), showHours)}${makeTimeBitString(Math.floor(leftMinutes).toString(), showMinutes)}${makeTimeBitString(
      Math.floor(leftSecond).toString(),
      showSeconds,
      true
    )}`;

    function makeTimeBitString(time: string, isShow?: boolean, isSecond?: boolean): string {
      if (!isShow) return '';
      let res: string;
      if (time.length < 2) {
        res = '0' + time;
      } else {
        res = time;
      }
      return `${res}${isSecond ? '' : ':'}`;
    }
  }
  makeRightZoneClass(type: 'normal' | 'split' | 'search' | 'counter' | undefined) {
    // 生成除了返回按钮以外的右侧部分的样式类名
    if (type === 'normal') {
      this.rightZoneClass = 'custom_zone_normal';
      this.makeTitleStyle('center');
    }
    if (type === 'split') {
      this.rightZoneClass = 'custom_zone_split';
      this.makeTitleStyle('left');
    }
    if (type === 'search') {
      this.rightZoneClass = 'custom_zone_split';
      this.makeTitleStyle('left');
    }
    if (type === 'counter') {
      this.rightZoneClass = 'custom_zone_split';
      this.makeTitleStyle('left');
    }
  }
  makeTitleStyle(titlePosition: 'center' | 'left') {
    // 生成头部样式
    if (titlePosition === 'center') {
      this.titleClass = `title_center_title`;
    } else {
      this.titleClass = '';
    }
  }
  handleSearchInputting(e: KeyboardEvent) {
    // 搜索事件的处理
    if (!this.configInstance.searchConfig) return;
    if (typeof this.configInstance.searchConfig.searchCallback !== 'function') return;
    if (e.keyCode === 13) {
      this.configInstance.searchConfig.searchCallback(this.searchWord);
    }
    return;
  }
  back() {
    // 返回
    if (this.timerFlag !== 0) {
      clearInterval(this.timerFlag);
    }
    if (window.history.length === 1 || window.history.length === 0) {
      this.$router.push('/ktpCourse');
      return;
    }
    if (this.configInstance.backConfig) {
      this.configInstance.backConfig();
    } else {
      this.$router.back();
    }
  }
  mounted() {
    this.renderNavBar(this.navInfo);
  }
}
